import styled from "styled-components";

export const SliderGoogle = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0 40px 40px;
  gap: 40px;

  #see-title {
    width: 100%;
    max-width: 1300px;

    #conf {
      font-weight: 700;
      font-size: 12px;
      line-height: 122%;
      text-transform: uppercase;
      color: var(--orange);
    }

    #see {
      width: 100%;

      h1 {
        font-weight: 700;
        font-size: 24px;
        line-height: 122%;
        color: var(--title);
        width: 85%;
      }
      button {
        display: none;
      }
    }
  }

  #slider {
    width: 100%;
    max-width: 1300px;

    .swiper-pagination-bullet {
      background-color: var(--orange);
    }

    .slides {
      min-height: 254px;
      background-color: var(--paragraph);
      border-radius: 4px;
      color: white;
      padding: 20px;

      .id {
        display: flex;
        justify-content: space-between;
        width: 100%;

        figure {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          margin: 0 auto;

          img {
            width: 100%;
          }
        }
      }

    }
  }

  @media (min-width: 601px) {
    #see-title {
      #see {
        display: flex;
        align-items: center;

        button, a {
          display: flex;
          align-items: center;
          justify-content: center;

          height: 56px;
          width: 320px;
          border-radius: 2px;
          border: none;
          background-color: var(--orange);
          color: var(--white);

          svg {
            font-size: 20px;
            margin-left: 5px;
          }
        }
      }
    }
  }
`;
